import React from 'react';

export default function OnSaleHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Our Current Sales</h2>
        </div>
      </div>
  );
}
